import { render, staticRenderFns } from "./IrisMenuDropdown.vue?vue&type=template&id=653170fe&"
import script from "./IrisMenuDropdown.vue?vue&type=script&lang=ts&"
export * from "./IrisMenuDropdown.vue?vue&type=script&lang=ts&"
import style0 from "./IrisMenuDropdown.vue?vue&type=style&index=0&id=653170fe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports